import { useState } from 'react'
import Cashflow from './Cashflow.jsx'
import Income from './Income.jsx'
import Builds from './Builds.jsx'
import Plans from './Plans.jsx'
import Subscriptions from './Subscriptions.jsx'
import NetWorth from './NetWorth.jsx'
import Reports from './Reports.jsx'

/**
 * The Cashflow category. It sits where 4ocean sits in Alex's app, and opens
 * the money screens instead of a list of notes.
 *
 * Seven sections behind one switch. Cashflow is first because it is the one he
 * opens daily; the rest are monthly at most. Subscriptions sits next to
 * Installments because they are the same question asked twice — what is already
 * committed — one that ends and one that does not.
 */
export const MONEY_SECTIONS = [
  { key: 'cashflow', label: 'Cashflow',      View: Cashflow },
  { key: 'income',   label: 'Income',        View: Income },
  { key: 'builds',   label: 'Builds',        View: Builds },
  { key: 'plans',    label: 'Installments',  View: Plans },
  { key: 'subs',     label: 'Subscriptions', View: Subscriptions },
  { key: 'networth', label: 'Net worth',     View: NetWorth },
  { key: 'reports',  label: 'Reports',       View: Reports },
]

export default function Money({ category, toast, section = 'cashflow', onSectionChange, jump = null, onJumpHandled }) {
  const [localKey, setLocalKey] = useState('cashflow')
  const key = onSectionChange ? section : localKey
  const { View } = MONEY_SECTIONS.find((s) => s.key === key) ?? MONEY_SECTIONS[0]

  return (
    <>
      {/* Same heading shape as every other category, which also keeps the
          sub-nav clear of the account button floating top-right. */}
      <div className="page-head">
        <span className="lbl">
          <i className="swatch" style={{ background: category?.color || 'var(--ocean)' }} />
          {' '}Category
        </span>
        <h1 className="serif">{category?.name || 'Cashflow'}</h1>
      </div>

      <div className="subnav" role="tablist" aria-label="Money sections">
        {MONEY_SECTIONS.map((s) => (
          <button
            key={s.key}
            type="button"
            role="tab"
            aria-selected={s.key === key}
            className={s.key === key ? 'on' : ''}
            onClick={() => (onSectionChange ? onSectionChange(s.key) : setLocalKey(s.key))}
          >
            {s.label}
          </button>
        ))}
      </div>
      <View toast={toast} jump={jump} onJumpHandled={onJumpHandled} />
    </>
  )
}
